/* ─────────────────────────────
   LATNOK — THEME JS
─────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {

  /* ── CART DRAWER ── */
  const cartToggle   = document.getElementById('cart-toggle');
  const cartClose    = document.getElementById('cart-close');
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartOverlay  = document.getElementById('cart-overlay');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggle  && cartToggle.addEventListener('click', openCart);
  cartClose   && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ── ADD TO CART (product grid buttons) ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__atc');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        await updateCartCount();
        btn.textContent = 'Added ✓';
        setTimeout(() => {
          btn.textContent = 'Add to Bag';
          btn.disabled = false;
        }, 1800);
        openCart();
      } else {
        btn.textContent = 'Error';
        btn.disabled = false;
      }
    } catch {
      btn.textContent = 'Error';
      btn.disabled = false;
    }
  });

  /* ── ADD TO CART (product page form) ── */
  const productForm = document.getElementById('product-form');
  const addToCartBtn = document.getElementById('add-to-cart');
  if (productForm && addToCartBtn) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1
          })
        });
        if (res.ok) {
          await updateCartCount();
          addToCartBtn.textContent = 'Added to Bag ✓';
          setTimeout(() => {
            addToCartBtn.textContent = 'Add to Bag';
            addToCartBtn.disabled = false;
          }, 2000);
          openCart();
        } else {
          const err = await res.json();
          addToCartBtn.textContent = err.description || 'Error';
          addToCartBtn.disabled = false;
        }
      } catch {
        addToCartBtn.textContent = 'Error';
        addToCartBtn.disabled = false;
      }
    });
  }

  /* ── CART COUNT ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const counts = document.querySelectorAll('#cart-count');
      counts.forEach(el => el.textContent = cart.item_count);
    } catch {}
  }

  /* ── QTY SELECTOR (product page) ── */
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus  = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('qty-input');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }

  /* ── PRODUCT GALLERY THUMBS ── */
  const galleryMain   = document.getElementById('gallery-active');
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (galleryMain) galleryMain.src = thumb.dataset.src;
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ── VARIANT SELECTOR (product page) ── */
  const variantInputs = document.querySelectorAll('.product-option__values input[type="radio"]');
  if (variantInputs.length > 0) {
    variantInputs.forEach(input => {
      input.addEventListener('change', updateVariant);
    });
    function updateVariant() {
      const selected = {};
      variantInputs.forEach(input => {
        if (input.checked) {
          const name = input.name.replace('options[', '').replace(']', '');
          selected[name] = input.value;
        }
      });
      if (window.__productVariants) {
        const match = window.__productVariants.find(v =>
          v.options.every((opt, i) => opt === Object.values(selected)[i])
        );
        if (match) {
          const idInput = document.querySelector('input[name="id"]');
          if (idInput) idInput.value = match.id;
          const priceEl = document.querySelector('.price--sale, .price--regular');
          if (priceEl && match.price) {
            priceEl.textContent = formatMoney(match.price);
          }
        }
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── MOBILE MENU ── */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu   = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
  }

  /* ── HEADER SCROLL EFFECT ── */
  const header = document.getElementById('site-header');
  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 100 && y > lastY) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
      lastY = y;
    }, { passive: true });
    header.style.transition = 'transform 0.3s ease';
  }

});
